/**
 * Attempts to get the label for the screen or build a label if no label can be found
 * @param screen
 */
export function getScreenLabel(screen: ScreenDetailed): string {
    if(screen.label.trim()) {
        return screen.label;
    }

    // Attempt to generate a label with unique identifiers (top and left most likely to be unique)
    const details: Array<string> = [];

    if(typeof screen.width !== "undefined") {
        details.push(`w:${screen.width}`);
    }

    if(typeof screen.height !== "undefined") {
        details.push(`h:${screen.height}`);
    }

    if(typeof screen.top !== "undefined") {
        details.push(`t:${screen.top}`);
    }

    if(typeof screen.left !== "undefined") {
        details.push(`l:${screen.left}`);
    }

    if(typeof screen.pixelDepth !== "undefined") {
        details.push(`pd:${screen.pixelDepth}`);
    }

    if(typeof screen.orientation?.angle !== "undefined") {
        details.push(`oa:${screen.orientation.angle}`);
    }

    if(typeof screen.orientation?.type !== "undefined") {
        details.push(`ot:${screen.orientation.type}`);
    }

    if(!details.length) {
        return "<<No Label>>";
    }

    return details.join(",");
}
